<div
  [ngClass]="['ion-color-' + color]"
  [class.first-item]="!isPanelExpanded"
  data-testid="collapsible"
>
  <ion-item
    [ngClass]="{ 'ion-no-padding': noPadding }"
    role="button"
    [attr.aria-expanded]="isPanelExpanded"
    detail="true"
    lines="none"
    [detailIcon]="isPanelExpanded ? 'chevron-up' : 'chevron-down'"
    [class.expanded]="isPanelExpanded"
    (click)="onExpandClick()"
  >
    <mable-heading
      class="no-margin half-margin-top"
      [heading]="headingType"
      [icon]="icon"
      [iconColor]="iconColor"
      [headingStyle]="headingStyle"
      [color]="headingColor"
      data-testid="heading"
    >
      {{ title }}
    </mable-heading>
  </ion-item>
  <ion-item
    *ngIf="isPanelExpanded"
    lines="none"
    [ngClass]="{ 'ion-no-padding': noPadding }"
    data-testid="content"
  >
    <ng-content select=".content"></ng-content>
  </ion-item>
</div>
<hr />
